// Copyright (c) 2021 WiseTime. All rights reserved.

import { Observable, of, throwError } from "rxjs"
import { Action } from "redux"
import { catchError, map, mergeMap } from "rxjs/operators"
import * as Actions from "../actions"
import * as Slice from "../slice"
import { TAGS_VIEW_MODE } from "."
import { ofType } from "redux-observable"

export type StorageReader = () => Observable<number>

export const load: StorageReader = () => {
  try {
    const data = localStorage.getItem(TAGS_VIEW_MODE)
    if (data !== null) {
      // convert to number for matching index from RecentOrderBy enum
      return of(Number(data))
    }
    return of()
  } catch (error) {
    return throwError(error)
  }
}

export const loadViewMode = (load: StorageReader) =>
  (action$: Observable<Action>): Observable<Action> =>
    action$.pipe(
      ofType(Actions.loadViewModeFromStorage),
      mergeMap(_ => load().pipe(
        map(Slice.setViewMode),
        catchError(_ => of(Actions.loadViewModeFromStorageFailed())),
      )),
    )

export default loadViewMode(load)

